<div class="page-content">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" [translate]="Button.Previous"></button></div>

     <h1 class="page_title" translate='order_summary.page_title'></h1>

     <!--
     <div class="prod_head" html='order_summary.selectionFor' [param]="childParam"></div>
     -->

     <div *ngFor="let child of childList; let i=index"  style="padding-bottom:2em;">

            <div class="prod_head" translate='order_summary.selectionFor' style="width:100%">
                  <br/>
                  <strong>{{child.childName}}</strong>
            </div>

            <div style="width:100%" *ngFor="let prod of child.products; let i=index" class="prod_line" [ngClass]="(i%2)==0?'even':'odd'">

                        <i class="glyphicon prod_icon" [ngClass]="(prod.isOptOut)?'glyphicon-exclamation-sign optOut':'glyphicon-ok-sign confirmation'"></i>
                        
                        <span class="prod_name" [translate]="prod.prodName" id="prod_{{i}}"></span> 

                        <span class="prod_price" [translate]="prod.price" id="price_{{i}}"></span> 

                        <span [hidden]="prod.type==4">
                              <a tabindex="0" class="prod_link" (click)="onEdit(i)" (keypress)="keyPressEnter($event, i)"  [ngClass]="{'bold':prod.isOptOut}"
                                 [title]="(prod.isOptOut?'order_summary.link_add_alt':'order_summary.link_edit_alt')|translate"
                                 [translate]="(prod.isOptOut)?'shared.link.add':'shared.link.edit'" attr.aria-labelledby="prod_{{i}} price_{{i}}"></a>
                        </span>
            </div>
      </div>





     <!-- div style="display:flex; justify-content:center; margin-right:2em;" -->
     <light-box outer-class="information-box">
            <information outer-style="width:100%">
                  <header-x (close)="onNoteClose()"></header-x>
                  <h2 style="margin-top:0.7em; text-align:center" translate='order_summary.please_note'></h2>

                  <div style="text-align: center; margin-top:0.4em" [translate]="message"></div>

                  <div class="btn-div" style="text-align: center">
                        <button class="btn-edit-back"  (click)="onConfirmNote()" [translate]="Button.Next"></button>
                  </div>
            </information>
     </light-box>
     

      <div style="display:flex; justify-content:center; margin-top:1em">
            <div *ngIf="data.subject.siteKey">
                  <div [hidden]="orderTotal > 0 || !isLastPage || data.isSubmit">
                        <re-captcha (resolved)="resolved($event)"  siteKey="{{data.subject.siteKey}}"> </re-captcha>     
                  </div>
            </div>
            
            <div class="wait-icon" [hidden]="!data.isSubmit" >
              <img src="refresh/assets/images/ChasingArrows.gif">
            </div>      
      </div>
  

      <div class="btn-div">

          <div [hidden]="orderTotal == 0 || !isLastPage">
                <button class="btn-next"               alt-text='order_summary.toPayment_alt' 
                       (click)="onNextClick()" 
                        translate='order_summary.toPayment_button'></button>
          </div>
          
          <div [hidden]="orderTotal > 0 && isLastPage || data.isSubmit">
                 <button class="btn-next"    [title]="Button.Next_alt|translate"   
                        [class.btn-disabled]="disabled&&isLastPage" 
                        (click)="onSubmit()" [translate]="Button.Next"></button>
          </div>

      </div>

</div>

